import * as React from 'react'

function SvgTickLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 262 226"
      {...props}
    >
      <path fill="#fff" d="M0 0h262v226H0V0z"></path>
      <path
        fill="#C2FFE7"
        d="M83.096 163.696c43.177 28.692 102.41 49.465 137.534 1.093 31.884-43.881 5.852-104.415-51.114-111.431-24.573-3.033-43.982 13.042-68.665 6.078-24.682-6.965-50.155-28.714-73.08-3.278-35.5 39.389 26.91 88.668 55.325 107.538z"
        opacity="0.3"
      ></path>
      <path
        fill="#00D37E"
        fillRule="evenodd"
        d="M32.36 180.282c.632 0 1.12.498 1.12 1.141 0 .644-.488 1.141-1.12 1.141-.632 0-1.12-.497-1.12-1.141 0-.643.488-1.141 1.12-1.141zm0-2.282c-1.842 0-3.36 1.546-3.36 3.423s1.518 3.423 3.36 3.423c1.842 0 3.36-1.546 3.36-3.423S34.202 178 32.36 178z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00D37E"
        d="M32.36 180.282c.632 0 1.12.498 1.12 1.141 0 .644-.488 1.141-1.12 1.141-.632 0-1.12-.497-1.12-1.141 0-.643.488-1.141 1.12-1.141zm0-2.282c-1.842 0-3.36 1.546-3.36 3.423s1.518 3.423 3.36 3.423c1.842 0 3.36-1.546 3.36-3.423S34.202 178 32.36 178z"
      ></path>
      <path
        fill="#00D37E"
        fillRule="evenodd"
        d="M226.545 30.766c1.043 0 1.848.821 1.848 1.884 0 1.062-.805 1.883-1.848 1.883-1.043 0-1.848-.821-1.848-1.883 0-1.063.805-1.884 1.848-1.884zm0-3.766c-3.04 0-5.545 2.552-5.545 5.65 0 3.097 2.505 5.649 5.545 5.649s5.545-2.552 5.545-5.65c0-3.097-2.505-5.649-5.545-5.649z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00D37E"
        d="M226.545 30.766c1.043 0 1.848.821 1.848 1.884 0 1.062-.805 1.883-1.848 1.883-1.043 0-1.848-.821-1.848-1.883 0-1.063.805-1.884 1.848-1.884zm0-3.766c-3.04 0-5.545 2.552-5.545 5.65 0 3.097 2.505 5.649 5.545 5.649s5.545-2.552 5.545-5.65c0-3.097-2.505-5.649-5.545-5.649z"
      ></path>
      <path
        fill="#00D37E"
        fillRule="evenodd"
        d="M228.828 197.323l-3.243-.571.488-3.236 3.25.573-.495 3.234zm3.086 4.212c.442-.326.736-.816.818-1.364l1.132-7.446c.175-1.161-.626-2.268-1.791-2.475l-7.47-1.316a2.078 2.078 0 00-2.429 1.732l-1.133 7.445c-.175 1.161.626 2.268 1.791 2.475l7.47 1.316a2.1 2.1 0 001.612-.367z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00D37E"
        d="M228.828 197.323l-3.243-.571.488-3.236 3.25.573-.495 3.234zm3.086 4.212c.442-.326.736-.816.818-1.364l1.132-7.446c.175-1.161-.626-2.268-1.791-2.475l-7.47-1.316a2.078 2.078 0 00-2.429 1.732l-1.133 7.445c-.175 1.161.626 2.268 1.791 2.475l7.47 1.316a2.1 2.1 0 001.612-.367z"
      ></path>
      <path
        fill="#42FFB4"
        fillRule="evenodd"
        d="M27.797 29.341l-.394-3.525 3.528-.433.395 3.533-3.529.425zm-3.455 4.42a2.294 2.294 0 001.675.451l8.12-.987a2.34 2.34 0 002.038-2.573l-.91-8.121a2.286 2.286 0 00-2.55-2.015l-8.12.986a2.34 2.34 0 00-2.037 2.573l.909 8.122c.068.62.383 1.184.875 1.564z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00D37E"
        d="M27.797 29.341l-.394-3.525 3.528-.433.395 3.533-3.529.425zm-3.455 4.42a2.294 2.294 0 001.675.451l8.12-.987a2.34 2.34 0 002.038-2.573l-.91-8.121a2.286 2.286 0 00-2.55-2.015l-8.12.986a2.34 2.34 0 00-2.037 2.573l.909 8.122c.068.62.383 1.184.875 1.564z"
      ></path>
      <path
        fill="#00D37E"
        fillRule="evenodd"
        d="M175.922 80.55a6.363 6.363 0 010 8.997L133.55 131.92a7.951 7.951 0 01-11.246 0l-19.174-19.174a6.363 6.363 0 018.997-8.997l15.8 15.8 38.998-38.998a6.362 6.362 0 018.997 0z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00D37E"
        d="M181.105 113.5c3.808 0 6.938 3.098 6.475 6.878a56.497 56.497 0 01-75.394 46.218 56.498 56.498 0 01-23.98-89.398 56.502 56.502 0 0159.164-17.923c3.655 1.07 5.262 5.17 3.756 8.667-1.507 3.498-5.559 5.052-9.253 4.127a42.71 42.71 0 1031.782 48.296c.612-3.758 3.642-6.865 7.45-6.865z"
      ></path>
      <path
        fill="#EDFFF8"
        d="M179.353 74.731l4.88-.731.767 2.664L181.223 81 179 79.262l.353-4.53z"
      ></path>
    </svg>
  )
}

export default SvgTickLogo
